<section class="c-section--static partner-signup">
	<div class="c-section__header c-text--center">
		<div [class]="headerClass">
			<div class="o-container">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'SIFFI'">
						<a id="headerLogoSiffi" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup__header-logo c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'MINUDOC'">
						<a id="headerLogoMinudoc" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup__header-logo partner-signup__header-logo--minudoc c-header__logo c-logo c-logo--{{ logoSuffix }}"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="product === 'PREVISIT'">
						<a id="headerLogoPrevisit" href="javascript:void(0);" (click)="navigateToRoot($event)" class="partner-signup__header-logo partner-signup__header-logo--previsit c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
					</div>
				</div>
			</div>

			<nav class="c-nav c-nav--tab-bar partner-signup__lang-nav">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<li class="c-nav__item" *ngIf="product === 'SIFFI'">
								<siffi-language-picker [currentLocale]="locale" (localeSelected)="setLocale($event)"></siffi-language-picker>
							</li>
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': langOpen }" *ngIf="product !== 'SIFFI'">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="toggleLangMenu()">
									<i class="c-flag c-flag--{{ getLocaleOption(locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ getLocaleOption(locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of locales; let $index = index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== locale" (click)="setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link">
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
		<main class="o-container c-container">
			<div class="partner-signup__shell">
				<div class="c-content partner-signup__intro">
					<p class="c-text c-text--center c-text--s6 partner-signup__tag">{{ 'PartnerSignup.Page_Tag' | translateUnauthenticated }}</p>
					<h1 class="c-text c-text--bold c-text--center partner-signup__title">{{ getTitleKey() | translateUnauthenticated }}</h1>
					<p class="c-text c-text--center partner-signup__subtitle">{{ 'PartnerSignup.Subtitle' | translateUnauthenticated }}</p>
				</div>

				<form class="c-form active" #partnerForm="ngForm" novalidate (ngSubmit)="submit(partnerForm)">
					<div class="o-grid o-grid--wrap partner-signup__grid">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-100@md-and-up o-grid__cell--w-30@lg-and-up">
							<div class="partner-signup__criteria">
								<p class="c-text c-text--bold u-osb-sm">{{ 'PartnerSignup.Criteria_Title' | translateUnauthenticated }}</p>
								<p class="c-text u-osb-sm">{{ 'PartnerSignup.Criteria_Description' | translateUnauthenticated }}</p>
								<ul class="partner-signup__criteria-list">
									<li class="c-text" *ngFor="let criterion of qualificationCriteria">{{ criterion | translateUnauthenticated }}</li>
								</ul>
							</div>
						</div>

						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-35@lg-and-up">
							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || fullName.touched) && fullName.invalid }">
								<label for="fullName" class="c-form__label">{{ 'PartnerSignup.Full_Name' | translateUnauthenticated }}</label>
								<input id="fullName" name="fullName" type="text" [(ngModel)]="formData.fullName" #fullName="ngModel" class="c-form__input c-form__input--sm c-form__input--round" required>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || fullName.touched) && fullName.invalid">
									{{ 'PartnerSignup.Full_Name' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || legalName.touched) && legalName.invalid }">
								<label for="legalName" class="c-form__label">{{ 'PartnerSignup.Legal_Name' | translateUnauthenticated }}</label>
								<input id="legalName" name="legalName" type="text" [(ngModel)]="formData.legalName" #legalName="ngModel" class="c-form__input c-form__input--sm c-form__input--round" required>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || legalName.touched) && legalName.invalid">
									{{ 'PartnerSignup.Legal_Name' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || regCode.touched) && regCode.invalid }">
								<label for="regCode" class="c-form__label">{{ 'PartnerSignup.Reg_Code' | translateUnauthenticated }}</label>
								<input id="regCode" name="regCode" type="text" [(ngModel)]="formData.regCode" #regCode="ngModel" class="c-form__input c-form__input--sm c-form__input--round" required>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || regCode.touched) && regCode.invalid">
									{{ 'PartnerSignup.Reg_Code' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || legalAddress.touched) && legalAddress.invalid }">
								<label for="legalAddress" class="c-form__label">{{ 'PartnerSignup.Legal_Address' | translateUnauthenticated }}</label>
								<textarea id="legalAddress" name="legalAddress" [(ngModel)]="formData.legalAddress" #legalAddress="ngModel" rows="3" class="c-form__input c-form__input--sm c-form__input--round" required></textarea>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || legalAddress.touched) && legalAddress.invalid">
									{{ 'PartnerSignup.Legal_Address' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm">
								<label for="vatNumber" class="c-form__label">{{ 'PartnerSignup.Vat_Number' | translateUnauthenticated }}</label>
								<input id="vatNumber" name="vatNumber" type="text" [(ngModel)]="formData.vatNumber" class="c-form__input c-form__input--sm c-form__input--round">
							</div>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': hasVatNumber() && (formSubmitted || vatRate.touched) && hasVatRateError() }">
								<label for="vatRate" class="c-form__label">{{ 'PartnerSignup.Vat_Rate' | translateUnauthenticated }}</label>
								<input id="vatRate" name="vatRate" type="text" inputmode="decimal" [(ngModel)]="formData.vatRate" #vatRate="ngModel" class="c-form__input c-form__input--sm c-form__input--round">
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="hasVatNumber() && (formSubmitted || vatRate.touched) && !formData.vatRate.trim()">
									{{ 'PartnerSignup.Vat_Rate' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="hasVatNumber() && (formSubmitted || vatRate.touched) && formData.vatRate.trim() && hasVatRateError()">
									{{ 'PartnerSignup.Vat_Rate' | translateUnauthenticated }} {{ 'Modal.Form.Error.Invalid' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': formSubmitted && !selectedCountry }">
								<label for="country" class="c-form__label">{{ 'PartnerSignup.Country' | translateUnauthenticated }}</label>
								<mat-select id="country" name="country" [(value)]="selectedCountry" class="mat-select mat-select--sm mat-select--border-round" required>
									<mat-option *ngFor="let countryItem of countries" [value]="countryItem">{{ countryItem.label }}</mat-option>
								</mat-select>
								<item-form-error-with-translator *ngIf="formSubmitted && !selectedCountry" [fieldName]="'PartnerSignup.Country' | translateUnauthenticated" [error]="{ 'required': true }"></item-form-error-with-translator>
							</div>

							<div class="c-form__group u-osb-sm">
								<label for="linkedin" class="c-form__label">{{ 'PartnerSignup.LinkedIn' | translateUnauthenticated }}</label>
								<input id="linkedin" name="linkedin" type="url" [(ngModel)]="formData.linkedin" class="c-form__input c-form__input--sm c-form__input--round" placeholder="https://www.linkedin.com/in/...">
							</div>

							<div class="c-form__group u-osb-sm">
								<label for="website" class="c-form__label">{{ 'PartnerSignup.Website' | translateUnauthenticated }}</label>
								<input id="website" name="website" type="url" [(ngModel)]="formData.website" class="c-form__input c-form__input--sm c-form__input--round" placeholder="https://...">
								<p class="c-text c-text--sm u-ost-sm">{{ 'PartnerSignup.Profile_Link_Help' | translateUnauthenticated }}</p>
							</div>

							<p class="c-text c-text--s3 c-text--center u-osb-sm" *ngIf="formSubmitted && !hasProfileLink()">{{ 'PartnerSignup.Link_Required' | translateUnauthenticated }}</p>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || email.touched) && email.invalid }">
								<label for="email" class="c-form__label">{{ 'PartnerSignup.Contact_Email' | translateUnauthenticated }}</label>
								<input id="email" name="email" type="email" [(ngModel)]="formData.email" #email="ngModel" class="c-form__input c-form__input--sm c-form__input--round" required email>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || email.touched) && email.errors?.['required']">
									{{ 'PartnerSignup.Contact_Email' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || email.touched) && email.errors?.['email']">
									{{ 'PartnerSignup.Contact_Email' | translateUnauthenticated }} {{ 'Modal.Form.Error.Invalid' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || phone.touched) && phone.invalid }">
								<label for="phone" class="c-form__label">{{ 'PartnerSignup.Phone' | translateUnauthenticated }}</label>
								<input id="phone" name="phone" type="tel" [(ngModel)]="formData.phone" #phone="ngModel" class="c-form__input c-form__input--sm c-form__input--round" required>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || phone.touched) && phone.invalid">
									{{ 'PartnerSignup.Phone' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>
						</div>

						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-35@lg-and-up">
							<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (formSubmitted || referenceCustomer.touched) && referenceCustomer.invalid }">
								<label for="referenceCustomer" class="c-form__label partner-signup__label-with-info">
									<span>{{ 'PartnerSignup.Reference_Customer' | translateUnauthenticated }}</span>
									<item-info-popover itemId="partner-reference-customer" [text]="'PartnerSignup.Reference_Customer_Info' | translateUnauthenticated" placement="bottom" placementMobile="top" [openOnHover]="true" class="partner-signup__info-popover"></item-info-popover>
								</label>
								<input id="referenceCustomer" name="referenceCustomer" type="text" [(ngModel)]="formData.referenceCustomer" #referenceCustomer="ngModel" maxlength="255" class="c-form__input c-form__input--sm c-form__input--round" required>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(formSubmitted || referenceCustomer.touched) && referenceCustomer.invalid">
									{{ 'PartnerSignup.Reference_Customer' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm">
								<label class="c-form__label">{{ 'PartnerSignup.Certificate' | translateUnauthenticated }}</label>
								<label class="c-file_upload u-osb-sm">
									<div class="c-file_upload__item">
										<img [src]="product === 'SIFFI' ? 'img/pin-siffi.svg' : 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/pin.svg'" alt="">
									</div>
									<div class="c-file_upload__item">
										<div class="c-text c-text--md">{{ 'PartnerSignup.Upload_Choose' | translateUnauthenticated }}</div>
										<div class="c-text c-text--sm">{{ uploads.certificate.files.length ? uploads.certificate.files.length + ' ' + ('PartnerSignup.Files_Selected' | translateUnauthenticated) : ('PartnerSignup.File_Help' | translateUnauthenticated) }}</div>
									</div>
									<input id="certificate" type="file" accept=".pdf,.jpg,.jpeg,.png" multiple (change)="onFileSelected('certificate', $event)">
								</label>
								<p class="c-text c-text--sm" *ngIf="uploads.certificate.uploading">{{ 'PartnerSignup.Uploading' | translateUnauthenticated }}</p>
								<div class="c-file_item" *ngFor="let file of uploads.certificate.files; let fileIndex = index">
									{{ file.fileName }}
									<div class="c-file_item__remove">
										<a href="javascript:void(0)" (click)="removeUploadedFile('certificate', fileIndex)">
											<i class="o-icon o-icon--x u-no-mr" style="color: red"></i>
										</a>
									</div>
								</div>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="uploads.certificate.errorKey">{{ uploads.certificate.errorKey | translateUnauthenticated }}</p>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="formSubmitted && !hasUploadedFile('certificate') && !uploads.certificate.uploading && !uploads.certificate.errorKey">
									{{ 'PartnerSignup.Certificate' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm">
								<label class="c-form__label">{{ 'PartnerSignup.Diploma' | translateUnauthenticated }}</label>
								<label class="c-file_upload u-osb-sm">
									<div class="c-file_upload__item">
										<img [src]="product === 'SIFFI' ? 'img/pin-siffi.svg' : 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/pin.svg'" alt="">
									</div>
									<div class="c-file_upload__item">
										<div class="c-text c-text--md">{{ 'PartnerSignup.Upload_Choose' | translateUnauthenticated }}</div>
										<div class="c-text c-text--sm">{{ uploads.diploma.files.length ? uploads.diploma.files.length + ' ' + ('PartnerSignup.Files_Selected' | translateUnauthenticated) : ('PartnerSignup.File_Help' | translateUnauthenticated) }}</div>
									</div>
									<input id="diploma" type="file" accept=".pdf,.jpg,.jpeg,.png" multiple (change)="onFileSelected('diploma', $event)">
								</label>
								<p class="c-text c-text--sm" *ngIf="uploads.diploma.uploading">{{ 'PartnerSignup.Uploading' | translateUnauthenticated }}</p>
								<div class="c-file_item" *ngFor="let file of uploads.diploma.files; let fileIndex = index">
									{{ file.fileName }}
									<div class="c-file_item__remove">
										<a href="javascript:void(0)" (click)="removeUploadedFile('diploma', fileIndex)">
											<i class="o-icon o-icon--x u-no-mr" style="color: red"></i>
										</a>
									</div>
								</div>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="uploads.diploma.errorKey">{{ uploads.diploma.errorKey | translateUnauthenticated }}</p>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="formSubmitted && !hasUploadedFile('diploma') && !uploads.diploma.uploading && !uploads.diploma.errorKey">
									{{ 'PartnerSignup.Diploma' | translateUnauthenticated }} {{ 'Modal.Form.Error.Required' | translateUnauthenticated }}
								</p>
							</div>

							<div class="c-form__group u-osb-sm">
								<label for="bio" class="c-form__label">{{ 'PartnerSignup.Short_Bio' | translateUnauthenticated }}</label>
								<textarea id="bio" name="bio" [(ngModel)]="formData.bio" rows="5" maxlength="300" class="c-form__input c-form__input--sm c-form__input--round" placeholder="{{ 'PartnerSignup.Short_Bio_Placeholder' | translateUnauthenticated }}"></textarea>
								<div class="o-grid u-ost-sm">
									<div class="o-grid__cell">
										<p class="c-text c-text--sm">{{ 'PartnerSignup.Bio_Help' | translateUnauthenticated }}</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed">
										<p class="c-text c-text--sm">{{ getBioLength() }}/300</p>
									</div>
								</div>
								<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="formSubmitted && hasBioLengthError()">{{ 'PartnerSignup.Invalid_Bio_Length' | translateUnauthenticated }}</p>
							</div>
						</div>
					</div>

					<p class="c-text c-text--s3 c-text--center u-osb-sm" *ngIf="submitFailed">
						{{ submitErrorKey | translateUnauthenticated }}
					</p>

					<div class="c-form__group partner-signup__submit">
						<button type="submit" class="c-button c-button--s1 c-form__center-button" [disabled]="isSubmitting || isUploading('certificate') || isUploading('diploma')">
							{{ 'PartnerSignup.Submit' | translateUnauthenticated }}
						</button>
					</div>
				</form>
			</div>
		</main>
	</div>
</section>
